import {css} from "@emotion/react";

import {calculateRemSize as crs, p} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";

import expertImage from "../images/marek-wielgo.png";

export function OfferRankingExpert() {
    return (
        <div css={offerRankingExpert}>
            <div css={wrap}>
                <div css={expertMessage}>
                    <Text variant="headline_2" as="h3">
                        Okiem eksperta
                    </Text>
                    <Text css={expertText}>
                        Preferencje kupujących kształtują przede wszystkim ich możliwości finansowe, zwłaszcza w kontekście lokalizacji i metrażu mieszkań.
                        Zarówno na rynku pierwotnym, jak i wtórnym, niezmiennie największym zainteresowaniem cieszą się lokale dwupokojowe. Dla większości
                        poszukujących idealnego lokum kluczowe jest położenie w dobrze skomunikowanej i bezpiecznej okolicy, z łatwym dostępem do sklepów,
                        szkół, przedszkoli, przychodni oraz terenów zielonych i rekreacyjnych. Coraz większą rolę odgrywają także udogodnienia, takie jak
                        miejsca parkingowe, rowerownie czy komórki lokatorskie. Jednak to koszty eksploatacji często decydują o ostatecznym wyborze.
                        Nieodłącznym elementem atrakcyjnego mieszkania jest balkon lub taras, a jeszcze większym atutem – prywatny ogródek. Trendy te
                        potwierdzają wyniki <b>Rankingu Inwestycji 2024</b>, w którym osiedla cieszące się największą popularnością to te spełniające kluczowe
                        oczekiwania nabywców: atrakcyjna lokalizacja, dostęp do infrastruktury miejskiej i nowoczesne rozwiązania podnoszące komfort życia.
                    </Text>
                </div>
                <div css={expert}>
                    <Image alt="Wojciech Sosnkowski" width="192px" height="192px" src={expertImage} css={expertImageStyle} />
                    <div css={expertDescription}>
                        <Text variant="headline_6" as="p" css={expertDescriptionAlign}>
                            Marek Wielgo
                        </Text>
                        <Text variant="info_txt_1" css={expertDescriptionAlign}>
                            {concatWithBrandName("Ekspert")}
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Styles
const offerRankingExpert = css`
    background: ${getThemeVariable("colors.gray.200")};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

const wrap = css`
    max-width: 936px;
    ${p(4, 3)};
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: ${crs(4)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex-direction: row;
        ${p(8, 3)};
    }
`;

const expertMessage = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        order: 1;
    }
`;

const expertText = css`
    font-style: italic;
`;

const expert = css`
    display: flex;
    gap: ${crs(2)};
    align-items: center;
    justify-content: center;

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex-direction: column;
        gap: ${crs(3)};
        order: 0;
    }
`;

const expertImageStyle = css`
    flex: 0 0 auto;
    width: ${crs(12)};
    height: ${crs(12)};
    border-radius: 50%;
    & > img {
        width: 100%;
        height: 100%;
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        width: ${crs(24)};
        height: ${crs(24)};
    }
`;

const expertDescription = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(0.5)};
    max-width: 244px;
`;

const expertDescriptionAlign = css`
    @media (min-width: ${getThemeBreakpoint().md}) {
        text-align: center;
    }
`;
